module.exports = __webpack_public_path__ + "assets/img/star-news.3e3ba110.svg";